import styled from 'styled-components';

import { mixins } from '../../../style/mixins';
import { Wrapper as SidebarWrapper } from './components/Sidebar/Sidebar.styled';

interface WrapperProps {
  $hasFooter: boolean;
  $isMenuVisible: boolean;
}

interface DesktopSidebarWrapperProps {
  $width?: string;
}

interface BodyProps {
  $hasBorderRadius: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { borderRadius, color }, $hasFooter, $isMenuVisible }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    maxHeight: 'inherit',
    backgroundColor: $isMenuVisible ? color.background.quaternary.default() : undefined,
    borderRadius: 'inherit',

    [SidebarWrapper]: {
      borderBottomLeftRadius: $hasFooter ? undefined : borderRadius.large,
    },
  }),
);

export const Body = styled.div<BodyProps>(({ $hasBorderRadius }) => ({
  display: 'flex',
  overflow: 'hidden',
  flexGrow: 1,
  borderRadius: $hasBorderRadius ? 'inherit' : undefined,
}));

export const DesktopSidebarWrapper = styled.div<DesktopSidebarWrapperProps>(
  ({ $width }) => ({
    display: 'flex',
    overflowX: 'hidden',
    width: $width || '30%',

    ...mixins.responsive.sm.downward({
      display: 'none',
    }),
  }),
);

export const MobileSidebarWrapper = styled.div({
  display: 'none',
  overflowX: 'hidden',
  width: '100%',

  ...mixins.responsive.sm.downward({
    display: 'flex',
  }),
});

export const RightContentWrapper = styled.div({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
});

export const Subbar = styled.div({
  width: '100%',
});
